import React, { useState }        from "react";
import ExtraChargeService        from 'services/extra-charge.service';
import AuthService                from 'services/auth.service';
import ExtraChargesTable          from './ExtraChargesTable';
import { Modal }                  from "react-bootstrap";
import CloseBtn                   from 'assets/icons/Close.svg';
import Spinner                    from 'react-bootstrap/Spinner';

function ExtraChargesConfirmModal({setShowExtraChargesConfirm, showExtraChargesConfirm, extraCharges, getTotal, chat_id, setExtraCharged}) {
  const [submitting, setSubmitting] = useState(false); 

  const submitExtraCharges = () => {
    setSubmitting(true);
    const params = {
      chat_session_id: chat_id,
      items: extraCharges
    }

    ExtraChargeService.submitExtraCharges(params).then(
      (data) => {
        setSubmitting(false);
        setExtraCharged(data.id)
      },
      (error) => {
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace('/eb/login');
        }
      }
    );
  }

  return (
    <Modal className="medicine-details-modal" size="lg" show={showExtraChargesConfirm} onHide={() => {setShowExtraChargesConfirm(false)}} backdrop="static" keyboard={false}>
      <Modal.Header>
        <button type="button" className="close" onClick={() => {setShowExtraChargesConfirm(false)}}>
            <img src={ CloseBtn } alt="modal-close" />
        </button>
      </Modal.Header>
      <Modal.Body>
        <h6>Confirmation</h6>
        <p>Please check that all the following charges are entered correctly. You are not able to retrieve or make changes once you send it to the patient.</p>
        <ExtraChargesTable extraCharges={extraCharges} getTotal={getTotal}/>
      </Modal.Body>
      <Modal.Footer>
        <div className="w-100 d-flex justify-content-between align-items-end">
          <div>
            {submitting ? <Spinner animation="border" className="spinner"/> : <button className="btn btn-danger" onClick={submitExtraCharges}>Confirm & Send</button> }
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default ExtraChargesConfirmModal;
